﻿import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Intent } from "@blueprintjs/core";
import { FormNumericInput, FormSelect, FormSuggest, FormTextInput } from "components/form-fields";
import { AssetService } from "services/AssetService";
import { NotificationToaster } from "components/notifications";
import { CollisionsService } from "services";

export function CollisionSettings(
    {
        selectedAsset = null,
        collision,
        errors,
        loading,
        onCollisionUpdate,
        saving
    }
) {

    const unknownOption = [{ id: null, name: "Unknown" }];
    const yesNoOptions = [
        ...unknownOption,
        { id: true, name: "Yes" },
        { id: false, name: "No" }
    ];
    const [injuryOptions, setInjuryOptions] = useState([]);
    const [damageOptions, setDamageOptions] = useState([]);
    const [assetList, setAssetList] = useState([]);

    useEffect(onInit, []);

    function onInit() {
        CollisionsService.getCollisionOptions().then(function (options) {
            setInjuryOptions([
                ...unknownOption,
                ...options.injuryLevels
            ]);

            setDamageOptions([
                ...unknownOption,
                ...options.damageLevels
            ]);
        });
    }

    function onAssetSearch(query) {

        var searchRequest = {
            requestCount: 50,
            pageNumber: 1,
            searchTerm: query,
            filters: [
                { key: "status", value: "active"}
            ]
        }

        AssetService.searchAssets(searchRequest).then(function (driverResponse) {
            setAssetList(driverResponse.data.map(function (d) {
                return {
                    id: d.assetId,
                    name: `${d.assetRegistration} - ${d.location.name}`
                }
            }));
        }, function () {
            NotificationToaster.show(Intent.WARNING, "Could not search for a specific employee, please try agian.");
            setAssetList([]);
        });
    }


    function onCollisionUpdateValue(field, value, convertNulls = false) {

        if (value === "" && convertNulls === true) {
            value = null;
        }

        onCollisionUpdate(field, value);
    }

    useEffect(function () {

        if (selectedAsset != null) {
            setAssetList([selectedAsset])
        }

    }, [selectedAsset]);

    return (
        <div>
            <FormSuggest
                loading={loading}
                disabled={saving}
                items={assetList}
                onItemSelect={(item) => onCollisionUpdateValue("assetId", item.id)}
                headingText="Asset involved in the collision:"
                selectedValue={collision.assetId}
                dangerHelperText={errors.assetId}
                onFilter={onAssetSearch}
                debounceTime={500}
                id="collision-asset"
            />
            <FormTextInput
                headingText="Area of damage:"
                onChange={(event) => onCollisionUpdateValue("areaOfDamage", event.target.value)}
                value={collision.areaOfDamage}
                loading={loading}
                disabled={saving}
                maxLength={255}
                id="collision-area-of-damage"
            />
            <FormSelect
                headingText="Was the driver at fault?"
                items={yesNoOptions}
                onItemSelect={(item) => onCollisionUpdateValue("driverAtFault", item.id)}
                selectedValue={collision.driverAtFault}
                loading={loading}
                disabled={saving}
                id="collision-driver-at-fault"
            />
            <FormSelect
                headingText="Was there third party involvement?"
                items={yesNoOptions}
                onItemSelect={(item) => onCollisionUpdateValue("thirdPartyInvolvement", item.id)}
                selectedValue={collision.thirdPartyInvolvement}
                loading={loading}
                disabled={saving}
                id="collision-third-party-involvement"
            />
            <FormSelect
                headingText="Injuries obtained:"
                items={injuryOptions}
                onItemSelect={(item) => onCollisionUpdateValue("collisionInjuryLevelId", item.id)}
                selectedValue={collision.collisionInjuryLevelId}
                loading={loading}
                disabled={saving}
                id="collision-injury-level"
            />
            <FormSelect
                headingText="Amount of damage caused:"
                items={damageOptions}
                onItemSelect={(item) => onCollisionUpdateValue("collisionDamageLevelId", item.id)}
                selectedValue={collision.collisionDamageLevelId}
                loading={loading}
                disabled={saving}
                id="collision-damage-level"
            />
            <FormNumericInput
                allowDecimal
                min={0}
                max={10000000}
                selectedValue={collision.repairCost}
                onValueChange={(item) => onCollisionUpdateValue("repairCost", item, true)}
                headingText="Repair cost:"
                id="collision-repair-cost"
                prefixText="&pound;"
                loading={loading}
                disabled={saving}
            />
            <FormNumericInput
                allowDecimal
                min={0}
                max={10000000}
                selectedValue={collision.totalCost}
                onValueChange={(item) => onCollisionUpdateValue("totalCost", item, true)}
                headingText="Total cost:"
                id="collision-total-cost"
                prefixText="&pound;"
                loading={loading}
                disabled={saving}
            />
        </div>
    );
}

CollisionSettings.propTypes = {
    loading: PropTypes.bool.isRequired,
    saving: PropTypes.bool.isRequired,
    collision: PropTypes.object.isRequired,
    onCollisionUpdate: PropTypes.func.isRequired,
    errors: PropTypes.array.isRequired,
    selectedAsset: PropTypes.object
};